export function passToRouteSearchParams(route: string, params: Record<string, string>) {
  return `${route}?${Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')}`;
}
